import React from 'react';
import { motion } from 'framer-motion';
export function AboutCarelizSection() {
  return <section className="py-24 bg-brand-brown-light px-6" data-id="element-14">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-2 lg:order-1" data-id="element-16">
          <div className="relative max-w-sm mx-auto" data-id="element-17">
            {/* Outer gold frame */}
            <div className="p-2 bg-brand-brown border-2 border-brand-gold rounded-lg shadow-2xl" data-id="element-18">
              {/* Inner gold accent line */}
              <div className="p-1 border border-brand-gold/60 rounded-md" data-id="element-19">
                <img src="https://cdn.magicpatterns.com/uploads/4mHtuDrxWieW93U2djMZwE/e61b41a4-3b66-4fa3-8466-b47c20d89930_4.jpg" alt="Careliz Griman" className="w-full h-auto object-cover rounded-sm" data-id="element-20" />
              </div>
            </div>
            {/* Decorative gold corner accents */}
            <div className="absolute -top-2 -left-2 w-6 h-6 border-t-2 border-l-2 border-brand-gold" data-id="element-21"></div>
            <div className="absolute -top-2 -right-2 w-6 h-6 border-t-2 border-r-2 border-brand-gold" data-id="element-22"></div>
            <div className="absolute -bottom-2 -left-2 w-6 h-6 border-b-2 border-l-2 border-brand-gold" data-id="element-23"></div>
            <div className="absolute -bottom-2 -right-2 w-6 h-6 border-b-2 border-r-2 border-brand-gold" data-id="element-24"></div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-8 flex items-center gap-3" data-id="element-26">
            <span className="text-brand-gold text-2xl" data-id="element-27">🌷</span>
            Un mensaje para ti
          </h2>

          <div className="relative" data-id="element-28">
            <span className="absolute -top-6 -left-4 text-6xl text-brand-gold/30 font-serif" data-id="element-29">
              "
            </span>
            <p className="text-xl md:text-2xl font-serif text-brand-cream/90 leading-relaxed italic relative z-10" data-id="element-30">
              Yo también sé lo que es sentirte perdida, insegura o pensar que
              quizás esto no es para ti.
              <br data-id="element-31" />
              <br data-id="element-32" />
              Por eso creé este espacio.
              <br data-id="element-33" />
              <br data-id="element-34" />
              Para acompañarte, ayudarte a ordenar tus ideas y demostrarte que
              sí puedes construir algo propio desde tu esencia, incluso si hoy
              sientes miedo o no sabes por dónde empezar.
            </p>
          </div>

          <div className="mt-10" data-id="element-35">
            <p className="font-script text-4xl text-brand-gold" data-id="element-36">
              Careliz Griman
            </p>
            <p className="text-sm uppercase tracking-[0.3em] text-brand-cream/70 mt-3 font-medium" data-id="element-37">
              Coach · Mentora · Speaker
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}